module.exports = __webpack_public_path__ + "img/COM-B-1-III.3d37f278.png";